import { Tag } from "@digdir/designsystemet-react";
import { useTranslation } from "react-i18next";
import type { MålerdataOpplastingerStatus } from "@/api/generated";

export const OpplastingStatus = ({
  opplastingStatus,
}: {
  opplastingStatus: MålerdataOpplastingerStatus | null;
}) => {
  const { t } = useTranslation();

  if (opplastingStatus == null) {
    return (
      <Tag
        className={"text-balder-text-info-default bg-balder-background-warning"}
      >
        {t("pages.maalerdata-perioder.statuser.ingen-registrert")}
      </Tag>
    );
  }

  if (opplastingStatus === "Opplastet") {
    return (
      <Tag
        className={"text-balder-text-info-default bg-balder-background-info"}
      >
        {t("pages.maalerdata-perioder.statuser.opplastet")}
      </Tag>
    );
  }

  if (opplastingStatus === "Låst" || opplastingStatus === "Prosessert") {
    return (
      <div className="flex flex-col gap-1">
        <Tag
          className={"text-balder-text-info-default bg-balder-background-info"}
        >
          {t("pages.maalerdata-perioder.statuser.låst")}
        </Tag>
        <span className="text-balder-text-subtle text-sm">
          {t("pages.maalerdata-perioder.under-behandling-tekst")}
        </span>
      </div>
    );
  }

  // Should not happen, but just in case
  console.warn(
    "Ukjent opplastingsstatus for målerdata periode:",
    opplastingStatus,
  );
  return null;
};
